import React from 'react';
import TextField from '@material-ui/core/TextField';
import {isUndefined,isEmpty} from 'lodash'
import {useSelector,useDispatch} from 'react-redux'
import {getAfidFormula} from 'actions'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

function KopplaMed(props) {
    const dispatch = useDispatch()
    const Afid = useSelector(state => state.auth.authUser.user_Afid)
    const AvtalFormula=useSelector(state=>state.accountsData.AvtalFormula)
    const ListOfAVPro=useSelector(state=>state.Avtal.ListOfAVPro)
    let Agreement = props.intl.formatMessage({ id: 'Agreement' });
    let Prospectus = props.intl.formatMessage({ id: 'Prospectus' });
    let Renegotiated = props.intl.formatMessage({ id: 'Renegotiated' });
    let Sales = props.intl.formatMessage({ id: 'Sales' });

    const [Value,setValue] = React.useState(0)
    React.useEffect(()=>{
        setValue(props.Value)
        dispatch(getAfidFormula(Afid))
    },[])
    React.useEffect(()=>{
        console.log(ListOfAVPro,"test1")
        setValue(0)
    },[ListOfAVPro])
    const getLabelAvtal = (item)=>{
        let text = ""
        for(let option of AvtalFormula){
            if(parseInt(option.isDelimiter) === 1){
                text +=option.text
            }else{
                if(option.text === 'ID'){text +=`${item.typeFlag===1?Agreement:item.typeFlag===2?Prospectus:item.typeFlag===4?Sales:Renegotiated} #19${item.id}`}
                if(option.text === 'Typ'){text +=`${item.Type}`}
                if(option.text === 'Leverantör'){text +=`${item.leverantor}`}
                if(option.text === 'Rubrik'){text +=`${item.title}`}
            }
        }
        if(String(text).trim() === "") return `${item.typeFlag===1?Agreement:item.typeFlag===2?Prospectus:item.typeFlag===4?Sales:Renegotiated} #19${item.id}`
        return text
    }
    const handleChange = (e)=>{
        setValue(e.target.value)
        props.onchangeHanelEvent("id",e.target.value)
    }
    return (
        <div>
        <TextField
         select
         label={<IntlMessages id="appKontoModule.Avtal.Connect"/>}
         variant="outlined"
         size="small"
         name="AvtalId"
         value={Value}
         error={parseInt(Value)===0}
         fullWidth
         onChange={handleChange}
         SelectProps={{
             native: true,
         }}
         InputLabelProps={{
             shrink: true,
           }}
        >
            <option key="0" value="0"><IntlMessages id="Choose"/></option>
            {
                isEmpty(ListOfAVPro)?"":
                ListOfAVPro.map((option) => (
                    <option key={option.id} value={option.id}>
                        {getLabelAvtal(option)}
                    </option>
                ))
            }
            </TextField>
    </div>
    );
}
export default injectIntl(KopplaMed);

